import { AxiosCampaignClient } from '@/repositories/clients/AxiosCampaignClient'

const resource = '/campaign';
const resource_yalda = '/yalda_engagement';

export default {

  save(payload){
    return AxiosCampaignClient.post(`${resource}/save`, payload);
  },

  verify(payload){
    return AxiosCampaignClient.post(`${resource}/verify`, payload);
  },

  /**
   * Retrieves details of a yalda of steps.
   * Method | get
   * Api address| /api/yalda_engagement
   *
   * @function
   * @memberof YaldaOfRepository
   * @name getSteps
   * @returns {Promise} A promise representing the result of the getSteps API call.
   * @throws {Error} Will throw an error if the request fails.
   */
  getSteps() {
    return AxiosCampaignClient.get(`${resource_yalda}`)
  },
}